import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const StyledMultiRangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  height: 90px;
`;

export const StyledSliderContainer = styled.div`
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const StyledSlider = styled.div`
  position: relative;
  width: 300px;
`;

const Track = styled.div`
  position: absolute;
  border-radius: 3px;
  height: 5px;
`;

export const StyledSliderTrack = styled(Track)`
  background-color: ${theme.colors.grey_5};
  width: 100%;
  z-index: 1;
`;

export const StyledSliderRange = styled(Track)`
  background-color: ${theme.colors.purple};
  z-index: 2;
`;

export const Thumb = styled.input<{ $zIndex?: number }>`
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  pointer-events: none;
  position: absolute;
  height: 0;
  width: 300px;
  outline: none;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    background-color: ${theme.colors.white};
    border: 2px solid ${theme.colors.grey_4};
    border-radius: 50%;
    cursor: pointer;
    height: 14px;
    width: 14px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }

  &::-moz-range-thumb {
    background-color: ${theme.colors.white};
    border: 2px solid ${theme.colors.grey_4};
    border-radius: 50%;
    cursor: pointer;
    height: 14px;
    width: 14px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }
`;

export const StyledThumbLeft = styled(Thumb)`
  z-index: ${(props) => props.$zIndex ?? 3};
`;

export const StyledThumbRight = styled(Thumb)`
  z-index: 4;
`;

export const StyledTickContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 290px;
`;

export const StyledTick = styled.div<{ $isMiddle: boolean }>`
  position: relative;
  width: 2px;
  height: 5px;
  background-color: ${(props) =>
    props.$isMiddle ? theme.colors.grey_5 : theme.colors.grey_3};

  &:before {
    content: attr(data-label);
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    font-weight: 400;
    color: ${theme.colors.grey_3};
    display: ${(props) => (props.$isMiddle ? "none" : "block")};
  }
`;

export const StyledTooltip = styled.div<{ $position: number }>`
  position: absolute;
  bottom: 30px;
  left: ${(props) => props.$position}%;
  transform: translateX(-50%);
  background-color: ${theme.colors.purple};
  padding: 4px 8px;
  border-radius: 4px;
  z-index: 1;
  white-space: nowrap;
`;

export const StyledTooltipArrow = styled.div`
  position: absolute;
  left: 40%;
  bottom: -4px;
  width: 8px;
  height: 8px;
  background-color: ${theme.colors.purple};
  transform: rotateZ(45deg);
  z-index: 2;
`;
